// The facet engine's own progressive-enhancement script. Import direction
// matches src/main.css: the THEME reaches into the engine, never the
// reverse. Bundled into this single deferred module — no extra request.
import '../inc/content/facets/assets/facets.js';

// Theme entry script. The `js` class gates any CSS that should only apply
// when JavaScript is available (progressive enhancement hook).
document.documentElement.classList.add('js');

// Form time-trap: stamp every mp-form's hidden `ts` field with the page-load
// time (ms). inc/forms.php rejects submissions filled in under 3s of this
// stamp (bot behavior) or older than 24h (replay) — see its file docblock.
for (const field of document.querySelectorAll('.mp-form input[name="ts"]')) {
  field.value = String(Date.now());
}

// Where-to-buy country jump (kydex26/where-to-buy, Phase 2 Task 12): the
// <select>'s option values ARE the location permalinks — navigate straight
// there on change. Pure enhancement: this <select> is never a facet/filter
// (X6), and the block's own <ul> (theme/blocks/where-to-buy/render.php) is
// the no-JS path to every location, so nothing else needs to happen here
// without JavaScript.
for (const select of document.querySelectorAll('[data-wtb-jump]')) {
  select.addEventListener('change', function () {
    if (select.value) window.location.assign(select.value);
  });
}

/* MP MOTION MODULE — scroll-triggered graphic motion + number count-up.
 * Contract + "how to build a new one": inc/motion.php, docs guide §5j.
 * Wrapped in an IIFE so nothing leaks to window (theme bundles run in global
 * scope as classic scripts — a bare top-level function would clobber globals,
 * e.g. Underscore's `_`). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Numbers: count each .stat-num[data-mp-count-to] up from 0 on scroll-in.
  function initCountUp() {
    var els = document.querySelectorAll('.stat-num[data-mp-count-to]');
    if (!els.length) return;
    var fmt = function (v, d, s) { return (d > 0 ? v.toFixed(d) : String(Math.round(v))) + s; };
    var run = function (el) {
      var to = parseFloat(el.dataset.mpCountTo);
      var dec = parseInt(el.dataset.mpDecimals, 10) || 0;
      var suf = el.dataset.mpSuffix || '';
      var final = el.textContent;
      if (!isFinite(to)) return;
      if (reduce) { el.textContent = final; return; }
      var dur = 1400, t0 = null;
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        if (p < 1) { el.textContent = fmt(to * e, dec, suf); requestAnimationFrame(step); }
        else { el.textContent = final; }
      };
      el.textContent = fmt(0, dec, suf);
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (es, o) {
      es.forEach(function (en) { if (en.isIntersecting) { run(en.target); o.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Graphics: opt <html> into motion (only when motion is allowed — so no-JS /
  // reduced-motion leaves every mark at its FINAL value), then add .is-inview
  // to each .mp-motion block once, firing its draw-on.
  function initMotion() {
    if (reduce) return;
    document.documentElement.classList.add('js-motion');
    var blocks = document.querySelectorAll('.mp-motion');
    if (!blocks.length) return;
    if (!('IntersectionObserver' in window)) {
      blocks.forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (es, o) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-inview'); o.unobserve(en.target); } });
    }, { threshold: 0.35 });
    blocks.forEach(function (el) { io.observe(el); });
  }

  initCountUp();
  initMotion();

  /* Keep --kydex-header-h equal to the header's ACTUAL height.
   *
   * `body.has-hero .site-header` pulls the page up by this much so the hero sits
   * under the transparent header. It was a fixed 129px, and the header is not a fixed
   * height: measured on stage it is 204px with the announcement banner showing and
   * 140px without, and it changes again at each breakpoint. The pull and the header
   * therefore disagreed in every state, which is the white band Larry saw at the top
   * of the page after dismissing the banner — the hero failed to move up with it.
   *
   * Measured rather than guessed, and re-measured whenever the header can change
   * size: on load, on resize, on font load, and immediately after a banner dismissal.
   */
  var headerEl = document.querySelector( '.site-header' );
  function syncHeaderHeight() {
    if ( ! headerEl ) { return; }
    var h = Math.round( headerEl.getBoundingClientRect().height );
    if ( h > 0 ) { document.documentElement.style.setProperty( '--kydex-header-h', h + 'px' ); }
  }
  syncHeaderHeight();
  window.addEventListener( 'resize', syncHeaderHeight );
  if ( document.fonts && document.fonts.ready ) { document.fonts.ready.then( syncHeaderHeight ); }

  /* Announcement banner: dismiss persists per message (key = md5 of text) in localStorage. */
  ( function () {
    var banner = document.querySelector( '.site-banner' );
    if ( ! banner ) return;
    var key = 'kydex26-banner-' + ( banner.getAttribute( 'data-banner-key' ) || '' );
    try {
      if ( window.localStorage.getItem( key ) === '1' ) { banner.remove(); syncHeaderHeight(); return; }
    } catch ( e ) {}
    var btn = banner.querySelector( '.site-banner__close' );
    if ( btn ) btn.addEventListener( 'click', function () {
      banner.remove();
      // The header just got shorter; the hero pull has to follow it or a band of
      // background is left where the banner was.
      syncHeaderHeight();
      try { window.localStorage.setItem( key, '1' ); } catch ( e ) {}
    } );
  } )();
})();

/* Header: scrolled state (legacy navbar.js: scrollY > 10), measured height for the hero pull-under,
   mobile panel, submenu toggles. No jQuery. */
( function () {
	var header = document.querySelector( '[data-header]' );
	if ( ! header ) return;
	var root = document.documentElement;
	var setHeight = function () { root.style.setProperty( '--kydex-header-h', header.getBoundingClientRect().height + 'px' ); };
	setHeight();
	if ( 'ResizeObserver' in window ) new ResizeObserver( setHeight ).observe( header ); else window.addEventListener( 'resize', setHeight );
	var onScroll = function () { header.classList.toggle( 'is-scrolled', window.scrollY > 10 ); };
	window.addEventListener( 'scroll', onScroll, { passive: true } );
	onScroll();

	var burger = header.querySelector( '.site-header__burger' );
	var panel = document.getElementById( 'site-panel' );
	function openPanel() { if ( ! panel ) return; panel.hidden = false; requestAnimationFrame( function () { panel.classList.add( 'is-open' ); } ); document.body.classList.add( 'has-panel-open' ); burger && burger.setAttribute( 'aria-expanded', 'true' ); var f = panel.querySelector( 'input, a, button' ); f && f.focus(); }
	function closePanel() { if ( ! panel ) return; panel.classList.remove( 'is-open' ); document.body.classList.remove( 'has-panel-open' ); burger && burger.setAttribute( 'aria-expanded', 'false' ); window.setTimeout( function () { panel.hidden = true; }, 500 ); burger && burger.focus(); }
	// Focus-trap helper: elements that are both tab-reachable AND actually
	// rendered right now (getClientRects().length excludes display:none —
	// e.g. a collapsed .menu--panel submenu — unlike offsetParent, which is
	// unreliable inside a position:fixed panel).
	function getFocusable( container ) {
		return Array.prototype.filter.call(
			container.querySelectorAll( 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])' ),
			function ( el ) { return el.getClientRects().length > 0; }
		);
	}
	if ( burger && panel ) {
		burger.addEventListener( 'click', function () { panel.hidden ? openPanel() : closePanel(); } );
		var close = panel.querySelector( '.site-panel__close' ); close && close.addEventListener( 'click', closePanel );
		document.addEventListener( 'keydown', function ( e ) { if ( e.key === 'Escape' && ! panel.hidden ) closePanel(); } );
		document.addEventListener( 'click', function ( e ) { if ( ! panel.hidden && ! panel.contains( e.target ) && ! burger.contains( e.target ) ) closePanel(); } );
		// Tab trap: while the panel is open, Tab/Shift+Tab cycle within it
		// instead of escaping onto page content sitting behind the overlay.
		document.addEventListener( 'keydown', function ( e ) {
			if ( e.key !== 'Tab' || panel.hidden ) return;
			var focusables = getFocusable( panel );
			if ( ! focusables.length ) return;
			var first = focusables[ 0 ], last = focusables[ focusables.length - 1 ];
			if ( e.shiftKey ) {
				if ( document.activeElement === first || ! panel.contains( document.activeElement ) ) { e.preventDefault(); last.focus(); }
			} else {
				if ( document.activeElement === last || ! panel.contains( document.activeElement ) ) { e.preventDefault(); first.focus(); }
			}
		} );
	}

	/* The primary (desktop) menu opens on hover / keyboard focus in CSS, so its parent items
	   carry no click handler. The utility menu and the mobile panel still toggle on click. */
	document.querySelectorAll( '.menu__toggle' ).forEach( function ( btn ) {
		if ( btn.closest( '.menu--primary' ) ) return;
		btn.addEventListener( 'click', function ( e ) {
			e.stopPropagation();
			var item = btn.parentElement, open = item.classList.contains( 'is-open' );
			var siblings = item.parentElement ? item.parentElement.querySelectorAll( ':scope > .menu__item.is-open' ) : [];
			siblings.forEach( function ( s ) { s.classList.remove( 'is-open' ); var t = s.querySelector( ':scope > .menu__toggle' ); t && t.setAttribute( 'aria-expanded', 'false' ); } );
			item.classList.toggle( 'is-open', ! open );
			btn.setAttribute( 'aria-expanded', String( ! open ) );
		} );
	} );
	document.addEventListener( 'click', function ( e ) {
		document.querySelectorAll( '.menu--utility .menu__item.is-open' ).forEach( function ( item ) {
			if ( ! item.contains( e.target ) ) { item.classList.remove( 'is-open' ); var t = item.querySelector( ':scope > .menu__toggle' ); t && t.setAttribute( 'aria-expanded', 'false' ); }
		} );
	} );
	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key !== 'Escape' ) return;
		document.querySelectorAll( '.menu__item.is-open' ).forEach( function ( item ) { item.classList.remove( 'is-open' ); var t = item.querySelector( ':scope > .menu__toggle' ); t && t.setAttribute( 'aria-expanded', 'false' ); } );
	} );
} )();

/* Header search typeahead (Phase 2 Task 11, K9/D9). Pure progressive
 * enhancement: `form.site-search` already submits natively to /search/?q=
 * (theme/inc/content/search.php's render_block_core/search filter repoints
 * the block's hard-coded action/field name), so with JS disabled the form
 * still works end to end — this script only adds suggestions on top.
 *
 * The endpoint (`GET /wp-json/kydex26/v1/search?q=`) is the SAME
 * kydex26_search_query() the results page's facet set is built on, so the
 * dropdown cannot rank or scope differently than the page Enter lands on
 * (the K9/D9 defect this task closes).
 *
 * Titles arrive esc_html()'d (plus the same kydex26_sup_marks() trademark
 * superscripting the results-page cards use) — see search.php's docblock —
 * so assigning them via innerHTML below is the deliberately safe half of
 * that pairing: entities decode as real characters, and any literal
 * `<`/`>` in a title can never be interpreted as a tag.
 */
( function () {
	var ENDPOINT = '/wp-json/kydex26/v1/search';
	var MIN_CHARS = 2;
	var DEBOUNCE_MS = 200;

	document.querySelectorAll( 'form.site-search' ).forEach( function ( form ) {
		var input = form.querySelector( '.wp-block-search__input' );
		if ( ! input ) return;

		var list = document.createElement( 'ul' );
		list.className = 'site-search__suggestions';
		list.hidden = true;
		list.setAttribute( 'role', 'listbox' );
		form.appendChild( list );

		input.setAttribute( 'aria-expanded', 'false' );
		input.setAttribute( 'aria-autocomplete', 'list' );
		input.setAttribute( 'autocomplete', 'off' );

		var debounce = null;
		var controller = null;
		var items = [];
		var activeIndex = -1;
		var uid = 0;

		function closeList() {
			list.hidden = true;
			list.innerHTML = '';
			items = [];
			activeIndex = -1;
			input.setAttribute( 'aria-expanded', 'false' );
			input.removeAttribute( 'aria-activedescendant' );
		}

		function setActive( i ) {
			var options = list.querySelectorAll( '.site-search__suggestion' );
			options.forEach( function ( el ) { el.classList.remove( 'is-active' ); } );
			if ( i > -1 && i < options.length ) {
				options[ i ].classList.add( 'is-active' );
				options[ i ].scrollIntoView( { block: 'nearest' } );
				input.setAttribute( 'aria-activedescendant', options[ i ].id );
				activeIndex = i;
			} else {
				input.removeAttribute( 'aria-activedescendant' );
				activeIndex = -1;
			}
		}

		function renderResults( results ) {
			items = Array.isArray( results ) ? results : [];
			activeIndex = -1;
			list.innerHTML = '';
			if ( ! items.length ) { closeList(); return; }
			items.forEach( function ( item, i ) {
				var li = document.createElement( 'li' );
				li.className = 'site-search__suggestion';
				li.id = 'site-search-option-' + ( ++uid );
				li.setAttribute( 'role', 'option' );
				var a = document.createElement( 'a' );
				a.className = 'site-search__suggestion-link';
				a.href = item.permalink;
				a.tabIndex = -1;
				a.innerHTML = item.title; // see file docblock: server esc_html()'d, safe to assign
				li.appendChild( a );
				list.appendChild( li );
			} );
			list.hidden = false;
			input.setAttribute( 'aria-expanded', 'true' );
		}

		function fetchResults( term ) {
			if ( controller ) controller.abort();
			controller = new AbortController();
			fetch( ENDPOINT + '?q=' + encodeURIComponent( term ), {
				signal: controller.signal,
				headers: { Accept: 'application/json' },
			} )
				.then( function ( r ) { return r.ok ? r.json() : []; } )
				.then( renderResults )
				.catch( function ( err ) { if ( err.name !== 'AbortError' ) closeList(); } );
		}

		input.addEventListener( 'input', function () {
			var term = input.value.trim();
			if ( debounce ) clearTimeout( debounce );
			if ( term.length < MIN_CHARS ) {
				if ( controller ) controller.abort();
				closeList();
				return;
			}
			debounce = setTimeout( function () { fetchResults( term ); }, DEBOUNCE_MS );
		} );

		input.addEventListener( 'keydown', function ( e ) {
			if ( list.hidden && e.key !== 'Escape' ) return;
			if ( e.key === 'ArrowDown' ) {
				e.preventDefault();
				setActive( Math.min( activeIndex + 1, items.length - 1 ) );
			} else if ( e.key === 'ArrowUp' ) {
				e.preventDefault();
				setActive( Math.max( activeIndex - 1, 0 ) );
			} else if ( e.key === 'Escape' ) {
				closeList();
			} else if ( e.key === 'Enter' ) {
				if ( activeIndex > -1 && items[ activeIndex ] ) {
					// A highlighted suggestion wins; otherwise fall through and
					// let the native form submission carry Enter to /search/?q=.
					e.preventDefault();
					window.location.assign( items[ activeIndex ].permalink );
				}
			}
		} );

		document.addEventListener( 'click', function ( e ) {
			if ( ! form.contains( e.target ) ) closeList();
		} );
	} );
} )();

/* Start the hero video once the page has loaded — on the devices that should have it.
 *
 * inc/hero-poster.php paints the hero's still with an <img> and strips `autoplay` from
 * the cover's background video, leaving `preload="none"` + `data-kydex-video-defer`.
 * Nothing else will ever start these, so this file is load-bearing, not an enhancement:
 * without it the hero is permanently a still.
 *
 * WHY THE VIDEO IS GATED AT ALL, measured rather than assumed. On the stage homepage,
 * Lighthouse 13.4.1 mobile scored 97 with every metric but two at 1.00. Re-running the
 * identical page with `--blocked-url-patterns=*hero_video*` — one file blocked, nothing
 * else changed — scored 100: LCP 2.3s -> 1.8s, Speed Index 3.3s -> 1.4s. The hero video
 * was the entire remaining deficit, and not because of when it is fetched. Speed Index
 * scores each frame against the FINAL frame of the trace, so a background video playing
 * through the whole measurement means no earlier frame ever counts as complete. A
 * smaller file would not change that; only not moving does.
 *
 * SO IT DOES NOT PLAY ON PHONES, and that is a product decision worth defending on its
 * own terms rather than as a score fix: it is a 1.07MB decorative background, served
 * from an origin with no Cache-Control, downloaded again on every visit, on the
 * connection and the battery least able to afford it. Phones get the still — which is
 * frame 0 of this same video, so they get the composition, just not the motion. Desktop
 * is unchanged.
 *
 * 782px is the theme's own breakpoint (theme.json, and every `@media (max-width: 781px)`
 * in main.css), not a number picked for this.
 *
 * Two more refusals, both about respecting what the visitor has already asked for:
 * `prefers-reduced-motion: reduce` is a request not to animate, and an autoplaying
 * background video is animation; `saveData` and a 2g-class `effectiveType` are the
 * browser saying this connection should not be spent on decoration.
 *
 * The breakpoint is watched rather than read once, so a desktop window narrowed to phone
 * width and widened again still ends up with a playing hero.
 *
 * `play()` returns a promise that REJECTS when a browser refuses autoplay. The video is
 * muted so policy should allow it, but a rejection must not surface as an unhandled
 * rejection in the console — and if it is refused the still is still showing, which is
 * the correct fallback. Hence the empty catch.
 */
( function () {
	var WIDE = '(min-width: 782px)';

	function wide() {
		return ! window.matchMedia || window.matchMedia( WIDE ).matches;
	}

	function motionWanted() {
		return ! (
			window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches
		);
	}

	function connectionAffordsIt() {
		var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
		if ( ! c ) {
			return true;   // nothing to go on; assume it is fine
		}
		return ! c.saveData && ! /(^|-)2g$/.test( c.effectiveType || '' );
	}

	function startDeferredVideos() {
		if ( ! wide() || ! motionWanted() || ! connectionAffordsIt() ) {
			return;   // leave the still in place; the <img> behind is the hero
		}
		var videos = document.querySelectorAll( 'video[data-kydex-video-defer]' );
		Array.prototype.forEach.call( videos, function ( video ) {
			video.removeAttribute( 'data-kydex-video-defer' );
			video.preload = 'auto';
			video.muted = true;          // belt and braces: policy requires it for autoplay
			var attempt = video.play();
			if ( attempt && typeof attempt.catch === 'function' ) {
				attempt.catch( function () { /* still stays; nothing to do */ } );
			}
		} );
	}

	/* On `load` (not DOMContentLoaded) so the fetch begins after the page's own resources
	 * are done, and the video can have the connection to itself. */
	if ( document.readyState === 'complete' ) {
		startDeferredVideos();
	} else {
		window.addEventListener( 'load', startDeferredVideos, { once: true } );
	}

	if ( window.matchMedia ) {
		var mq = window.matchMedia( WIDE );
		var onChange = function () {
			if ( mq.matches ) {
				startDeferredVideos();
			}
		};
		if ( mq.addEventListener ) {
			mq.addEventListener( 'change', onChange );
		} else if ( mq.addListener ) {
			mq.addListener( onChange );   // Safari < 14
		}
	}
} )();
